import React from 'react';
import './style.css'
import QRCode from "react-qr-code";
import { store } from '../../../redux/store';
import { setGoHome } from '../../../redux/slices/initLoad/types';
import { useSelector } from 'react-redux';
import ChangeLanguage from '../../../components/changeLang';
import { useTranslation } from 'react-i18next';

const Index = ({ showBack = true, showImageTop = false, children, showLogo=true, showFooter=true, setShowListProduct, setShowSpecials, goHome, goCategories }) => {
   
    const [showModal, setShowModal] = React.useState(false);
  const { i18n } = useTranslation();
  

   const [showBoost, setshowBoost] = React.useState(false);
    const [showModalPincode, setShowModalPincode] = React.useState(false);
  const [secret, setScret] = React.useState("");
  
    const langEng = i18n.language === 'en' ?? false;
      const {
      goHomeInit
      } = useSelector((state) => state.initLoad);
  
  const handleButtonClick = () => {
    if (setShowListProduct) {
      setShowListProduct(false); 
    }
  };
  
   const validScret = () => {

    if (secret === '') {
      alert('Debe ingresar el pin')
    }

    if (secret === "2355") {
       window.location.reload();
    } else {
       alert('Code invalid')
    }
    
  }
  
    return (
      <div className='backgroundlayout' style={{
        flex: 1,
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
      }}>

        {/* <video
          className='backgroundlayout-video'
          autoPlay
          muted
          loop
          playsInline
        >
          <source src={require('./assets/bk.mp4')} type='video/mp4' />
        </video> */}

        
        <div>
          {/*<button onClick={()=>setOpenNav(!openNav)} style={{...styles.iconMenuMobile, ...iconMenu}}>
            <Menu />
          </button>*/}
          

          <div className='contentChild' >

            <div className='nav-menu-bar' style={{
             
              width: '100%',
              position: 'relative'
            
            }}>
               
              {showLogo &&
              <div style={{
               
                paddingTop: 20,
                paddingBottom: 20,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: showBack ? 'space-between':'center',
            
                }}>
                  
                  <div style={{ display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',}}>
                     {showBack && (
                        <div
                            onClick={()=>handleButtonClick()}
                                style={{
                                  width: 140,
                                  height: 40,
                                  display: 'flex',
                                  textAlign: 'center',
                                  alignItems: 'center',
                                  justifyContent: "center",
                                  cursor: 'pointer',
                                  marginLeft: 35,
                                  zIndex: 999,
                                  position: 'relative',
                                  background: "#C70100",
                                  borderRadius: 10,
                                    background: "#FEBA29",
                                  paddingInline: 10,
                                  boxSizing: 'border-box',
                                  border: '2px solid white',
                                    boxShadow: "0px 0px 20px rgba(255, 215, 0, 0.9)",
                            }}>
                           
                        <p style={{ position: 'absolute', color: 'white', fontSize: 20, fontWeight: '900' , textTransform: "uppercase"}}>
                          
                          {langEng ? 'GO BACK' : 'Ir atras'}
                          </p>
                          </div>
                    )}

                  </div>
                  
                  <div style={{
                      alignItems: 'center',}}   >
                       <div style={{
                      
                        display: 'flex',
                          alignItems: 'center',
                              position: 'relative',
                              zIndex: 999,
                              justifyContent: 'end',}}>
                        <div onClick={()=>setShowModal('https://www.instagram.com/labonitabr/?hl=en')} target='_blank'> <img
                        style={{
                          width: 28,
                            height: 28,
                            marginInline: 10
                        
                      }}
                      src={require('./assets/instagram.png')}
                      alt="Logo"
                      /> 
                      </div>

                      <div target='_blank' onClick={()=>setShowModal('https://m.facebook.com/LabonitaBarRestaurant/')}> 
                        <img
                          style={{
                              width: 28,
                                height: 28,
                                marginInline: 10
                        }}
                          src={require('./assets/facebook.png')}
                          alt="Logo"
                        /> 
                      </div>
                      <ChangeLanguage />

                      {/* <div target='_blank' onClick={()=>setShowModal('https://stanciaperuvianfusion.com/?fbclid=PAZXh0bgNhZW0CMTEAAabcJIytXY618p9SWTbgSUCDqZjeqqwDe6N-mVtvD2e3OsRHHxJ4b-C03sg_aem_ySjBYnYb0DeoIbZGrDsMbQ')}> 
                        <img
                          style={{
                              width: 30,
                                height: 30,
                                marginInline: 10
                        }}
                          src={require('./assets/web.png')}
                          alt="Logo"
                        /> 
                      </div>
                             */}
                  
                    <div>
                    
                    </div>
                      </div>
                  </div>

                 
              </div>
              }
              


            

            </div>
            {children}

            
            {showFooter &&
            <div
            style={{
              position: 'absolute',
              bottom: 0,
                  alignSelf: 'center',
                
                  width: '100%',
                  left: 0,
                
              
            }}>
            <div
              style={{
                paddingHorizontal: 40,
                paddingVertical: 15,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                  marginTop: 5,
                gap: 20,
                    width: '100%',
                
              }}>
              <div

                    onClick={() => {
                      handleButtonClick()
                         store.dispatch(setGoHome(!goHomeInit));
                        console.log({goHome})
                      if (goHome) {
                        goHome()
                      }
                  }}
                style={{
                  width: 210,
                height: 50,
                  borderRadius: 9,
                    marginHorizontal: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingHorizontal: 50,
                    alignItems: 'center',
                    flexDirection: 'row',
                    background: "#FEBA29",
                     paddingInline: 40,
                  boxSizing: 'border-box',
                  border: '2px solid white',
                    boxShadow: "0px 0px 20px rgba(255, 215, 0, 0.9)",
                  }}>
                
                     <img src={require('./assets/home.png')} style={{width: 30, height: 30}}  />

                <p
                    style={{
                      color: '#fff',
                      fontWeight: '800',
                      fontSize: 22,
                      textTransform: 'uppercase',
                       margin: 0,
                       
                    }}>
                    Home
                  </p>
                  </div>
                   <div

                    onClick={() => {
                      if (goCategories) {
                        goCategories(true)
                      }
                  }}
                style={{
                 width: 210,
                height: 50,
                  borderRadius: 9,
                    marginHorizontal: 10,
                    display: 'flex',
                    justifyContent: 'space-between',
                    paddingHorizontal: 50,
                    alignItems: 'center',
                    flexDirection: 'row',
                    background: "#FEBA29",
                    paddingInline: 10,
                  boxSizing: 'border-box',
                  border: '2px solid white',
                    boxShadow: "0px 0px 20px rgba(255, 215, 0, 0.9)",
                  }}>
                
                    <img src={require('./assets/cat.png')} style={{width: 30, height: 30}}  />
                <p
                    style={{
                      color: '#fff',
                      fontWeight: '800',
                      fontSize: 22,
                      textTransform: 'uppercase',
                       margin: 0,
                       
                      }}>
                      {langEng ? 'Categories': 'Categorias'}
                    
                  </p>
              </div>

              <div
                    onClick={() => {
                      if (setShowSpecials) {
                        setShowSpecials(true)
                      }
                }}
                style={{
                 width: 210,
                height: 50,

                  borderRadius: 9,
                  marginHorizontal: 10,
                  justifyContent: 'space-between',
                    paddingHorizontal: 50,
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                  background: "#FEBA29",
                   paddingInline: 10,
                  boxSizing: 'border-box',
                  border: '2px solid white',
                    boxShadow: "0px 0px 20px rgba(255, 215, 0, 0.9)",
                  }}>
                     <img src={require('./assets/promo.png')} style={{width: 30, height: 30}}  />
                <p
                    style={{
                      color: '#fff',
                      fontWeight: '800',
                      fontSize: 22,
                      margin: 0,
                      textTransform: 'uppercase',
                      
                      }}>
                      {langEng ? 'Especials': 'Especiales'}
                    
                  </p>
                
              </div>
            </div>
            <div
              style={{
                zIndex: 100,
                flexDirection: 'row',
                justifyContent: 'space-around',
                paddingHorizontal: 20,
                paddingVertical: 5,
                  alignItems: 'center',
                marginTop: 20,
              }}>
                  <div
                    onClick={()=> setshowBoost(true)}
                style={{flexDirection: 'row', alignItems: 'center'}}>
                <p
                  style={{
                      color: '#fff',
                      fontWeight: '300',
                      textAlign: 'center',
                      fontSize: 14,
                    }}>
                 Powered by boostyourmenu.com v1.3
                </p>
              </div>
            </div>
          </div>
          }
            

            
            {showBoost &&
              <div onClick={ ()=> setshowBoost(false)} style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                <img
                 
                            style={{
                              width: 500,
                                height: 500,
                                marginInline: 10,
                                objectFit: 'contain',
                                zIndex: 9999
                            
                          }}
                          src={require('./assets/boost.png')}
                          alt="Logo"
                /> 
            
            </div>
            }
            

              {showModalPincode &&
              <div style={{ position: 'absolute', top: 0, bottom: 0, left: 0, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999, flexDirection: 'column' }}>
                
                <div style={{ position: 'absolute',background: '#fff', width: 500, height: 300, borderRadius: 30, display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: "column" }}>
                  <img
                      onClick={()=>setShowModalPincode(false)}
                    style={{
                      position: 'absolute',
                      top: -10,
                      
                                width: 40,
                                  height: 40,
                                  marginInline: 10,
                                  objectFit: 'contain',
                                  position: 'absolute',
                                  right: -10,
                                  zIndex: 9999
                              
                            }}
                      src={require('./assets/close.png')}
                      alt="Logo"
                  /> 
                  <h4 style={{ color: '#F40000', fontSize: 40, fontWeight: 'bold', margin: 20 }}>PIN</h4>
                  <input type='number' style={{ width: 300, height: 40 }} onChange={(e) => {
                    setScret(e.target.value)
                  }} />
                  <br /><br />
                  
                  <div style={{display: 'flex', gap: 20}}>
                    <div onClick={() => setShowModalPincode(false)} style={{background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7}}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>atras</p>
                    </div>
                    <div onClick={()=>validScret()} style={{ background: '#FF1616', width: 150, height: 50, justifyContent: 'center', alignItems: 'center', display: 'flex', borderRadius: 7 }}>
                      <p style={{color: 'white', textTransform: 'uppercase', fontWeight: 'bold'}}>Enviar</p>
                  </div>
                </div>
                </div>
              </div>
            }

            <img
                onClick={()=>setShowModalPincode(true)}
                        style={{
                          width: 40,
                            height: 40,
                            marginInline: 10,
                            objectFit: 'contain',
                            position: 'absolute',
                            bottom: -1,
                            right: 0,
                            zIndex: 9999
                        
                      }}
                src={require('./assets/pincode.png')}
                alt="Logo"
            /> 
            
            {showModal &&  <div onClick={()=>setShowModal(false)} style={{position: 'absolute', top: 0, bottom: 0, left: 0,width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999}}>
              <QRCode
              size={256}
              style={{ height: 400,  width: 400 }}
              value={showModal}
              divBox={`0 0 256 256`}
            />
            </div>}
           
          </div>
        </div>
      </div>
     
    );
  };

export default Index;